








































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  name: 'TableMaterial',
  data() {
    return {
      titleTrainingMaterials: 'Total Type Material Visited',
      alignCard: 'center',
      fieldsTrainingMaterials: [
        {
          key: 'no',
        },
        {
          key: 'file_code',
        },
        {
          key: 'title',
        },
        {
          key: 'category',
        },
        {
          key: 'car_type',
        },
        {
          key: 'created_date',
        },
        {
          key: 'total_visit',
        },
        {
          key: 'total_user',
        },
      ],
      tableTrainingMaterials: [
        {
          id: 1,
          material_name: 'Xpander New Feature',
          category: 'Category A',
          car_type: 'LVC',
          total_view: 21,
          total_user: 70,
        },
        {
          id: 2,
          material_name: 'Pajero New Feature',
          category: 'Category B',
          car_type: 'LVC',
          total_view: 21,
          total_user: 20,
        },
        {
          id: 3,
          material_name: 'Fortuner New Feature',
          category: 'Category C',
          car_type: 'LVC',
          total_view: 21,
          total_user: 70,
        },
        {
          id: 4,
          material_name: 'Xpander New Feature',
          category: 'Category A',
          car_type: 'LVC',
          total_view: 21,
          total_user: 70,
        },
        {
          id: 5,
          material_name: 'Xpander New Feature',
          category: 'Category A',
          car_type: 'LVC',
          total_view: 21,
          total_user: 70,
        },
      ],
    }
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public linkExport
  @Prop({}) public isDisabledExport
}
